import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { SbHint } from '@kistler/skybase-ui/skybase-components/sb-hint'

export const CalibrationExpirationWarning = ({ isExpired, isExpiringSoon, expiredMessage, expiringSoonMessage }) => {
  const { formatMessage: _ } = useIntl()
  if (isExpired) {
    return (
      <SbHint hintData={_(expiredMessage, { newLine: <br /> })}>
        <span className="sbi-toast-warning color-error" />
      </SbHint>
    )
  }
  if (isExpiringSoon) {
    return (
      <SbHint hintData={_(expiringSoonMessage, { newLine: <br /> })}>
        <span className="sbi-toast-warning warning" />
      </SbHint>
    )
  }
  return null
}

CalibrationExpirationWarning.propTypes = {
  isExpired: PropTypes.bool,
  isExpiringSoon: PropTypes.bool,
  expiredMessage: PropTypes.object.isRequired,
  expiringSoonMessage: PropTypes.object.isRequired,
}
